import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { ReduxStateType } from "redux-store/types";

interface InitialState {
  status: ReduxStateType;
  data: boolean | null;
}

const initialState: InitialState = {
  status: ReduxStateType.ERROR,
  data: null,
};

const getCheckEditableSlice = createSlice({
  name: "getCheckEditable",
  initialState,
  reducers: {
    getCheckEditableStart: (state) => {
      state.status = ReduxStateType.LOADING;
    },
    getCheckEditableSuccess: (state, action: PayloadAction<boolean>) => {
      state.status = ReduxStateType.SUCCESS;
      state.data = action.payload;
    },
    getCheckEditableFailed: (state) => {
      state.status = ReduxStateType.ERROR;
    },
    resetCheckEditable: () => {
      return { ...initialState };
    },
  },
});

export const {
  getCheckEditableStart,
  getCheckEditableSuccess,
  getCheckEditableFailed,
  resetCheckEditable,
} = getCheckEditableSlice.actions;

export default getCheckEditableSlice.reducer;
